export const __AskForHomeLang = {
    title: 'درخواست خانه مستقل',
    return: 'بازگشت',
};
